import React, { useEffect, useRef } from 'react';
import { Input } from '/ui/atoms';

// Old @flow
// type LinkInputProps = {
//   href: string,
//   handleChange: (event: SyntheticInputEvent<HTMLInputElement>) => void
// }

export const LinkInput = ({ href, handleChange, ref }) => {
  const inputRef = ref || useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus({ preventScroll: true });

      const value = inputRef.current.value;
      if (value) {
        const len = value.length;
        inputRef.current.setSelectionRange(len, len);
      }
    }
  }, []);

  return (
    <Input
      type="text"
      name="href"
      value={href}
      ref={inputRef}
      onChange={handleChange}
    />
  );
};

export default LinkInput;
